import { render, staticRenderFns } from "./ComplaintEmisorForm.vue?vue&type=template&id=a2b9d66a&scoped=true"
import script from "./ComplaintEmisorForm.vue?vue&type=script&lang=js"
export * from "./ComplaintEmisorForm.vue?vue&type=script&lang=js"
import style0 from "./ComplaintEmisorForm.vue?vue&type=style&index=0&id=a2b9d66a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b9d66a",
  null
  
)

export default component.exports